import { useEffect } from "react";
import { useColorScheme } from "@mui/material";
import type { Monaco } from "@monaco-editor/react";
import { setMonacoTheme } from "../utils/monacoTheme.utils";

export function useMonacoTheme(monacoRef: React.RefObject<Monaco | null>) {
  const { mode } = useColorScheme();

  // Switch theme when color mode changes (themes are defined at mount)
  useEffect(() => {
    if (monacoRef.current && mode) {
      setMonacoTheme(monacoRef.current, mode as "light" | "dark");
    }
  }, [mode, monacoRef]);

  return mode as "light" | "dark";
}
